var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "new-payroll",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.create($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("PayrollDetails", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("PayrollReceiver", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("PayrollPercepts", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "observe-visibility",
              rawName: "v-observe-visibility",
              value: _vm.onTotalsVisibleChange,
              expression: "onTotalsVisibleChange"
            }
          ],
          staticClass: "action-buttons is-flex"
        },
        [
          _c(
            "div",
            {
              staticClass: "box totals wrapper-salary-receipt-totals",
              class: {
                "totals-is-not-visible has-background-info": !_vm.totalsIsVisible
              }
            },
            [
              _c("div", [
                _c(
                  "div",
                  { class: [_vm.totalsIsVisible ? "is-7" : "is-narrow"] },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "title is-5",
                        class: [
                          _vm.totalsIsVisible
                            ? "has-text-primary"
                            : "has-text-white"
                        ]
                      },
                      [
                        _vm._v(
                          "\n            Total: " +
                            _vm._s(
                              _vm._f("toCurrency")(
                                _vm.$store.getters["payroll/total"]
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          ),
          _c("div", { staticClass: "field is-grouped" }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-success",
                  class: { "is-loading": _vm.loading },
                  attrs: { type: "submit", disabled: _vm.loading }
                },
                [_vm._v("\n          Generar Recibo de Salario\n        ")]
              )
            ]),
            _c(
              "p",
              { staticClass: "control" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass: "button is-danger",
                    class: { "is-loading": _vm.loading },
                    attrs: { disabled: _vm.loading, to: { name: "Home" } }
                  },
                  [_vm._v("\n          Cancelar\n        ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("RouterView")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }